module.exports = __webpack_public_path__ + "static/media/fluent_reward-12-regular.3b745369.svg";